import { AxiosError } from "axios";
import ERROR_CODE from "./error_code";


export interface AppError {
  message: string | string[] | object;
  code: string;
  status?: number;
  fieldErrors?: Record<string, string>;
  raw?: unknown; // optional, for debugging/logging
  visibility?: "toast" | "ui" | "none"
}

const handleError = (err: any): AppError => {
  if (err instanceof AxiosError) {
    return handleAxiosError(err);
  }
  return err

}

const handleAxiosError = (err: AxiosError): AppError => {
  if (err.code === ERROR_CODE.ERR_NETWORK) {
    return {
      code: ERROR_CODE.ERR_NETWORK,
      message: "Network Error",
      visibility: "ui"
    }
  }
  return {
    code: err.code || ERROR_CODE.UNKNOWN,
    message: err.message,
  }
}

export default handleError;
